var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAzure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "56px",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/56px/Azure") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.7772704%",
    y1: "7.4114724%",
    x2: "37.4681736%",
    y2: "103.76182%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0669BC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "59.5795763%",
    y1: "52.3127289%",
    x2: "52.6528657%",
    y2: "54.8636556%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.3,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.2,
    offset: "7.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.1,
    offset: "32.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.05,
    offset: "62.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "36.926907%",
    y1: "4.60005789%",
    x2: "62.8185696%",
    y2: "99.9794963%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2892DF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/56px/Azure",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-23",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9, 9)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Microsoft_Azure"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.59811,0.000434195291 L23.7804878,0.000434195291 L12.172082,34.7738325 C11.9274415,35.5065075 11.2478708,36 10.483001,36 L1.78034702,36 C1.20696292,36 0.668650812,35.7208971 0.334203213,35.2500255 C-0.000244385951,34.7791539 -0.0898759405,34.174237 0.0934133136,33.6249517 L10.9085996,1.2266017 C11.1531425,0.493603842 11.8329688,0 12.59811,0 L12.59811,0.000434195291 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8963206,23.6842105 L12.2330664,23.6842105 C11.8970102,23.6838445 11.5949617,23.8863243 11.4716698,24.1946173 C11.3483779,24.5029102 11.4289629,24.8542026 11.6748067,25.0801467 L23.0248057,35.5270946 C23.3552604,35.8310825 23.7903723,36 24.2422826,36 L34.2439024,36 L29.8963206,23.6842105 Z",
    id: "Path",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6431809,0 C11.8660151,-0.00299069556 11.1772652,0.503545642 10.9434401,1.25007592 L0.104844026,33.5953922 C-0.0915774607,34.146861 -0.00885618491,34.7601457 0.326516362,35.238842 C0.661888909,35.7175383 1.20782819,36.0015765 1.78949715,36 L10.7503171,36 C11.4297702,35.8777153 11.9913508,35.3966657 12.2202933,34.7408126 L14.3817188,28.3246349 L22.1023272,35.5779507 C22.4258636,35.8475023 22.831723,35.9965468 23.2515813,36 L33.2926829,36 L28.8887893,23.3239502 L16.0508531,23.3269896 L23.9081132,0 L12.6431809,0 Z",
    id: "Path",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8190935,1.22443072 C27.5688126,0.492613619 26.8730911,0 26.0901368,0 L13.3170732,0 C14.0999838,0 14.7956344,0.492697173 15.0460299,1.22443072 L26.1310719,33.6240834 C26.3190688,34.173469 26.2272885,34.7785475 25.8845096,35.2495913 C25.5417306,35.7206351 24.9899246,36 24.4021152,36 L37.175619,36 C37.7633507,36 38.3150254,35.7204373 38.6577016,35.249415 C39.0003777,34.7783926 39.0921077,34.1733964 38.9041355,33.6240834 L27.8190935,1.22443072 Z",
    id: "Path",
    fill: "url(#linearGradient-3)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzure);
export default __webpack_public_path__ + "static/media/Azure.4f8e640e3a2a3a9d3a575d63b4d17417.svg";
export { ForwardRef as ReactComponent };